<template>
    <main role="main">
        <div class="layout-contents wide-contents">
            <settings-header :menu="'3'"></settings-header>
            <div class="layout-contents-inner">
                <div class="lr-fold">
                    {{ $t('SETTING.ACCOUNT.PERMISSION_MNG')}}<br>
                    {{ $t('SETTING.ACCOUNT.NOT_IN_SCOPE')}}
                </div>
            </div>
        </div>
    </main>

</template>




<script>

    import settingsHeader from './settingsHeader.vue';

    export default {
        name: 'settings-account',
        components: {
            settingsHeader
        },
        data: function() {
            return {

            }
        },
        methods: {
        }

    }
</script>




// WEBPACK FOOTER //
// src/components/settings/settingsAccount.vue